









/* 
Expansion Panel:
https://github.com/mui-org/material-ui/blob/master/docs/src/pages/demos/expansion-panels/DetailedExpansionPanel.js
Popper:
https://github.com/mui-org/material-ui/blob/master/docs/src/pages/utils/popper/PositionedPopper.js

*/

import React, { Component } from "react";
import FilterListIcon from '@material-ui/icons/FilterList';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles'
import Popover from '@material-ui/core/Popover';

import * as CA from '../actions/CustomerActions';
import * as WA from '../actions/QuickWinActions';
import * as RA from '../actions/RollBarActions';
import * as QA from '../actions/QAActions';
import * as DH from '../others/DataHelpers';
import customerStore from '../stores/CustomerStore';
import quickWinStore from '../stores/QuickWinStore';
import rollBarStore from '../stores/RollBarStore';
import qaStore from '../stores/QAStore';

const styles = theme => ({
    root: {
        width: '100%',
        textAlign: 'right'
    },
    filter: {
        width: '2%',
    },
    popper: {
        padding: '10px'
    },
    menu: {
    },
    status: {

    },
    assignment: {

    },
    release: {

    },
    severity: {

    },
    updated: {

    },
    wide: {
        width: '100%'
    },
    accept: {},
    reject: {},
    heading: {
        fontSize: theme.typography.pxToRem(15),
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    icon: {
        verticalAlign: 'bottom',
        height: 20,
        width: 20,
    },
    details: {
        alignItems: 'center',
    },
    column: {
        flexBasis: '50%',
    },
    helper: {
        borderLeft: `2px solid ${theme.palette.divider}`,
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
});

class CustomTableFilter extends Component {

    constructor(props) {
        super(props)
        const { pathname } = this.props.location;
        const component = pathname.substring(1, pathname.length);


        switch (component) {
            case 'qa':
                this.Action = QA;
                this.Store = qaStore;
                break;
            case 'customer':
                this.Action = CA;
                this.Store = customerStore;
                break;
            case 'rollbar':
                this.Action = RA;
                this.Store = rollBarStore;
                break;
            case 'quickwin':
                this.Action = WA;
                this.Store = quickWinStore;
                break;
            default:
        }

        this.getStore = this.getStore.bind(this);
        const { filter, meta } = this.Store.getAll();
        const { status, release, severity, assignment, updated } = filter;

        this.state = {
            anchorEl: null,
            open: false,
            filterOpen: null,
            filterAnchorEl: null,
            filter,
            meta,
            status: status,
            release: release,
            severity: severity,
            assignment: assignment,
            updated: updated,
            component
        }
    }

    // --- HOOKS ---

    componentDidMount() {
        this.Store.on('change', this.getStore)
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search) {
            const { filter } = DH.parseParams(nextProps.location)
            const { status, release, severity, assignment, updated } = filter;
            this.setState({
                status,
                release,
                severity,
                assignment,
                updated,
            })
        } else if (
            this.state.filter.severity !== this.state.severity
            || this.state.filter.release !== this.state.release
            || this.state.filter.assignment !== this.state.assignment
            || this.state.filter.status !== this.state.status
            || this.state.filter.updated !== this.state.updated
        ) {
            this.setState((state) => ({
                release: state.filter.release,
                severity: state.filter.severity,
                assignment: state.filter.assignment,
                status: state.filter.status,
                updated: state.filter.updated
            }))
        }
    }

    componentWillUnmount() {
        this.Store.removeListener('change', this.getStore)
    };

    // --- Flux ---

    getStore = () => {
        const { filter, meta } = this.Store.getAll();
        this.setState({
            filter,
            meta
        })
    }

    // --- EVENTS ---

    handleFilterUpdate = () => {
        const currentFilter = this.state.filter;
        let currentMeta = this.state.meta;
        currentMeta.loading = true;

        this.Action.updateMeta(currentMeta);
        const searchParam = DH.createUrlParams(currentFilter);
        this.Action.updateTickets({
            search: searchParam
        });
    }

    handleFilterOpen = (event) => {
        const { classes } = this.props;
        const { currentTarget } = event;

        // open/close selected 
        if (currentTarget.classList && currentTarget.classList.contains(classes.filter)) {
            return this.setState((state) => ({
                anchorEl: currentTarget,
                open: !state.open,
            }));

            // close when clicking outside
        } else {
            this.setState({
                open: false,
                filterOpen: null
            })
        }
    }

    handleFilterConfirm = async (event) => {
        const { classes } = this.props;
        const { currentTarget } = event;

        // accept
        if (currentTarget.classList.contains(classes.accept)) {
            await this.setState((state) => ({       // need await so handleFilter(state) uses correct state
                filter: {
                    status: state.status,
                    assignment: state.assignment,
                    release: state.release,
                    severity: state.severity,
                    updated: state.updated
                },
                open: false,
                filterOpen: null,
            }));

            this.handleFilterUpdate();

            // reject
        } else if (currentTarget.classList.contains(classes.reject)) {
            return this.setState((state) => ({
                status: state.filter.status,
                assignment: state.filter.assignment,
                release: state.filter.release,
                severity: state.filter.severity,
                updated: state.filter.updated,
                open: false,
                filterOpen: null
            }))
        }
    }


    handleClick = async (event) => {
        const { classes } = this.props;
        const { filter } = this.state;
        const { currentTarget } = event;

        // dropdown
        if (currentTarget.classList) {

            for (let filterKey in filter) {
                if (currentTarget.classList.contains(classes[filterKey])) {

                    // select dropdown
                    if (currentTarget.getAttribute('role') === 'menuitem') {
                        return this.setState((state) => ({
                            filterAnchorEl: null,
                            filterOpen: null,
                            [filterKey]: currentTarget.textContent.split(' ')[0],
                        }))

                        // open/close dropdown
                    } else {
                        return this.setState((state) => ({
                            filterAnchorEl: currentTarget,
                            filterOpen: (state.filterOpen) ? null : filterKey
                        }));
                    }
                }
            }

            // click outside focused dropdown
            return this.setState((state) => ({
                open: (state.filterOpen) ? state.open : false,
                filterOpen: null
            }));

            // escape key
        } else {
            this.setState({
                open: false,
                filterOpen: null
            })
        }
    }


    // --- HELPERS ---

    checkFilterOpen = (label) => {
        return this.state.filterOpen === label;
    }

    // --- COMPONENTS ---

    createFilterDropdown = (choicesObj) => {
        const { classes } = this.props;
        const { filterAnchorEl } = this.state;
        const { id, choices } = choicesObj;
        let append = (id === 'updated') ? 'days' : '';
        return (
            <Menu
                anchorEl={filterAnchorEl}
                open={this.checkFilterOpen(id)}
                onClose={this.handleClick} className={classes[id]}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {choices
                    .map((choice) => (
                        <MenuItem
                            className={classes[id]}
                            onClick={this.handleClick}
                            key={choice}
                        >
                            {`${choice} ${append}`}
                        </MenuItem>
                    ))
                }
            </Menu>
        )
    }

    createFilterMenu = (filters) => {
        const { classes } = this.props;
        const { status, release, severity, assignment, updated } = this.state;
        const paramedUrl = DH.createUrlParams({
            status: status,
            release: release,
            severity: severity,
            assignment: assignment,
            updated: updated
        });
        return (
            <div>
                {filters
                    .map((filter) =>{
                        let append = (filter === 'updated') ? 'days' : '';

                        return (
                            <div key={filter} >
                                <Button
                                    variant='outlined'
                                    className={classNames(classes[filter], classes.wide)}
                                    onClick={this.handleClick}
                                >
                                    {filter}: {`${this.state[filter]} ${append}`}
                                </Button>
                                <br></br>
                            </div>
                        )
                    })}
                <Button
                    className={classes.reject}
                    onClick={this.handleFilterConfirm}
                    variant='outlined'
                >
                    Cancel
                </Button>
                <Link to={paramedUrl}>
                    <Button
                        variant='outlined'
                        className={classes.accept}
                        onClick={this.handleFilterConfirm}
                    >
                        Apply
                    </Button>
                </Link>
            </div>
        )
    }

    // --- RENDER ---

    render() {
        window.tf = this.state;
        const { classes } = this.props;
        const { anchorEl, open, filter } = this.state;


        return (
            <div className={classes.root}>
                <Button
                    className={classes.filter}
                    onClick={this.handleFilterOpen}
                >
                    <FilterListIcon
                        className={classes.filter}
                    ></FilterListIcon>
                </Button>
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    onEscapeKeyDown={this.handleFilterOpen}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    onBackdropClick={this.handleFilterOpen}
                >
                    <Paper
                        className={classes.popper}
                    >
                        {this.createFilterMenu(Object.keys(filter))}
                        {this.createFilterDropdown({
                            id: 'status',
                            choices: ['OPEN', 'BLOCKED', 'CLOSED', 'ANY']
                        })}
                        {this.createFilterDropdown({
                            id: 'assignment',
                            choices: ['NONE', 'ANY', 'ALL', 'ME']
                        })}
                        {this.createFilterDropdown({
                            id: 'release',
                            choices: ['NONE', 'ANY', 'ALL', 'CURRENT', 'PAST3']
                        })}
                        {this.createFilterDropdown({
                            id: 'severity',
                            choices: ['NONE', 'ANY', 'ALL', 'SEV0', 'SEV1', 'SEV2', 'SEV3', 'SEV4']
                        })}
                        {this.createFilterDropdown({
                            id: 'updated',
                            choices: ['7', '14', '30', '90', '365' ]
                        })}
                    </Paper>
                </Popover>
            </div>
        );
    }
}

export default withStyles(styles)(CustomTableFilter);


// WEBPACK FOOTER //
// ./src/js/components/Table_Filter.js